import alertMessage from 'global/AlertMessage';
import { postShareTradeShare } from 'lib/api/shareTrade';
import { PostShareRequestBody } from 'typings/api/shareTradeShare';
import create from 'zustand';

type TransactionData = Omit<
  PostShareRequestBody,
  'save_as_autoshare' | 'targets'
>;

interface State {
  isLoading: boolean;
  error?: Error;
  transactionData?: TransactionData;
}

interface Actions {
  setTransactionData(transactionData: TransactionData): void;
  loadShareTradeShare(requestBody: PostShareRequestBody): Promise<void>;
}

const initialState: State = {
  isLoading: false,
  error: undefined,
  transactionData: undefined,
};

const useShareTradeShare = create<State & Actions>((set) => ({
  ...initialState,
  setTransactionData: (transactionData) => {
    set({ transactionData });
  },
  loadShareTradeShare: async (requestBody) => {
    try {
      set({ isLoading: true });
      await postShareTradeShare(requestBody);
      set({ isLoading: false, error: undefined });
    } catch (error) {
      set({ isLoading: false, error });

      alertMessage({
        alertType: 'plain-default',
        messageType: 'error',
        content: 'Unable to share trade at this moment',
      });

      return Promise.reject(error);
    }
  },
}));

export default useShareTradeShare;
